// src/data/productosAgricolas.js
export default [
  {
    categoria: "Rodamientos Agrícolas",
    productos: [
      {
        nombre: "Rígido de Bolas Agrícola",
        slug: "rigido-de-bolas-agricola",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-agricolas/rigido-de-bolas-agricola.webp"),
      },
      {
        nombre: "De Agujas Agricola",
        slug: "de-agujas-agricola",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-agricolas/de-agujas-agricola.webp"),
      },
      {
        nombre: "Rodillos Cónicos Agrícolas",
        slug: "rodillos-conicos-agricolas",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-agricolas/rodillos-conicos-agricolas.webp"),
      },
      {
        nombre: "Rodamiento Agrícola",
        slug: "rodamiento-agricola",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-agricolas/rodamiento-agricola.webp"),
      },
    ],
  },
  {
    categoria: "Rodamientos Autocentrantes Agrícolas",
    productos: [
      {
        nombre: "Línea Agricola",
        slug: "linea-agricola",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-autocentrantes/linea-agricola.webp"),
      },
      {
        nombre: "Rodillos Sembradores",
        slug: "rodillos-sembradores",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-autocentrantes/rodillos-sembradores.webp"),
      },
      {
        nombre: "Eje Hexagonal",
        slug: "agricolas-eje-hexagonal",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-autocentrantes/agricolas-eje-hexagonal.webp"),
      },
      {
        nombre: "Eje Cuadrado",
        slug: "agricolas-eje-cuadrado",
        imagen: require("@/assets/images/productos-agricolas/rodamientos-autocentrantes/agricolas-eje-cuadrado.webp"),
      },
    ],
  },
];
